export const live = {
    zbz: "라이브 중",
    ljks: "지금 시작",
    hmyzb: "아직 라이브를 진행한 적이 없습니다~",
    zbyg: "라이브 예고",
    yjs: "종료됨",
    jszb: "라이브 종료",
    gbzb: "라이브 닫기",
    jxzb: "라이브 계속",
    bctp: "이미지 저장",
    fxlj: "링크 공유",
    zbydk: "라이브 연결이 끊어졌습니다. 잠시 후...",
    fh: "돌아가기",
    wjcdypsb: "오디오 장치가 감지되지 않음",
    czsb: "Canvas 작업 실패:",
    tpjzsb: "이미지 로딩 실패, URL이 정확하고 이미지에 접근 가능한지 확인해 주세요",
    zbjl: "라이브 기록",
    sqjl: "신청 기록",
    lts: "채팅방",
    ren: "명",
    gdcy: "더 많은 멤버",
    cy: "멤버",
    jcjy: "뮤트 해제",
    jy: "뮤트",
    qbjy: "전체 뮤트",
    zbjs: "라이브 소개",
    srnr: "내용을 입력해 주세요",
    tczbj: "라이브 방에서 퇴장되었습니다",
    qd: "확인",
    zbjjjs: "라이브가 10분 후 자동 종료됩니다!",
    zbsc: "라이브 시간:",
    ljgkrs: "누적 시청자 수:",
    dzs: "좋아요 수:",
    zbjies: "라이브 종료",
    ybjy: "뮤트되었습니다",
    jycg: "뮤트 해제 성공",
    jinycg: "뮤트 성공",
    qbjinycg: "전체 뮤트 성공",
    qbjycg: "전체 뮤트 해제 성공",
    cwzb: "스트리머 되기",
    lxgzry: "스태프에게 연락하여 스트리머가 되세요",
    lxfs: "연락 방법",
    zb: "라이브",
    xkt: "Biking 클래스",
    sqzb: "라이브 신청",
    bczbzt: "이번 라이브 주제",
    srzt: "주제를 입력해 주세요",
    bczbjj: "이번 라이브 소개",
    kbsj: "라이브 시작 시간",
    xzrisj: "날짜 시간 선택",
    tishi: "알림",
    dksdzb: "해당 시간에 대기 중인 라이브가 1개 있습니다",
    cxsj: "지속 시간",
    xzsc: "시간 선택",
    fmt: "커버 이미지",
    fmtbnwk: "커버 이미지는 비워둘 수 없습니다",
    sc: "업로드",
    yssc: "최대 10MB, 압축 후 업로드해 주세요",
    sccct: "360*170 크기의 이미지를 업로드해 주세요",
    tjsq: "신청 제출",
    tpcj: "이미지 크롭",
    tzcjwz: "크롭 프레임 위치 조정, 유지할 영역 선택",
    scdtp: "업로드된 이미지",
    yl: "미리보기 (360×170)",
    cjtp: "이미지 크롭",
    quxiao: "취소",
    qsrzbjj: "라이브 소개를 입력해 주세요",
    qxzrq: "날짜를 선택해 주세요",
    qxzsc: "시간을 선택해 주세요",
    kssjdydqsj: "시작 시간은 현재 시간보다 커야 합니다",
    sctxtpdx: "업로드하는 이미지 크기는 10MB를 초과할 수 없습니다!",
    tjcg: "제출 성공",
    jkshnr: "신청 내용을 최대한 빨리 검토하겠습니다",
    hmysqgzb: "아직 라이브를 신청한 적이 없습니다~",
    shz: "검토 중",
    tongg: "승인됨",
    jujue: "거절됨",
    yugao: "예고",
    huifang: "다시보기",
}


// WEBPACK FOOTER //
// ./src/i18n/lang/live/kr.js